import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

export const CARD = "rounded-lg border border-[#E2E8F0] bg-white";
export const INPUT = "w-full rounded-md border border-[#E2E8F0] bg-white px-3 py-2 text-sm text-[#0F172A] outline-none focus:border-[#C5A059] focus:ring-1 focus:ring-[#C5A059]";
export const BTN = "inline-flex items-center justify-center gap-2 rounded-md bg-[#2C201A] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[#C5A059] disabled:opacity-50";
export const BTN_GHOST = "inline-flex items-center justify-center gap-2 rounded-md border border-[#E2E8F0] px-3 py-2 text-sm font-medium text-[#334155] hover:bg-[#F8F9FA]";

const STATUS_COLORS = {
  "NEW ENQUIRY": "bg-blue-50 text-blue-700", "NEW": "bg-blue-50 text-blue-700",
  "CONTACTED": "bg-amber-50 text-amber-700", "QUOTATION SENT": "bg-amber-50 text-amber-700",
  "PROPOSAL": "bg-amber-50 text-amber-700", "NEGOTIATION": "bg-orange-50 text-orange-700",
  "CONFIRMED": "bg-green-50 text-green-700", "ACTIVE": "bg-green-50 text-green-700",
  "PREPARATION": "bg-indigo-50 text-indigo-700", "IN SERVICE": "bg-purple-50 text-purple-700",
  "ON HOLD": "bg-gray-100 text-gray-600", "COMPLETED": "bg-emerald-50 text-emerald-700",
  "CANCELLED": "bg-red-50 text-red-700",
};

export function StatusPill({ status }) {
  return <span className={`inline-block rounded-full px-2.5 py-1 text-[11px] font-semibold ${STATUS_COLORS[status] || "bg-gray-100 text-gray-600"}`}>{status}</span>;
}

export function StatCard({ label, value, hint, accent }) {
  return (
    <div className={`${CARD} p-5`}>
      <div className="text-[11px] font-semibold uppercase tracking-wider text-[#64748B]">{label}</div>
      <div className={`mt-2 font-display text-3xl ${accent ? "text-[#C5A059]" : "text-[#0F172A]"}`}>{value}</div>
      {hint && <div className="mt-1 text-xs text-[#94A3B8]">{hint}</div>}
    </div>
  );
}

export function PageTitle({ title, subtitle, right }) {
  return (
    <div className="mb-6 flex items-end justify-between">
      <div>
        <h1 className="font-display text-3xl text-[#0F172A]">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-[#64748B]">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function useList(path, deps = []) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(() => {
    setLoading(true);
    api.get(path).then(({ data }) => setData(data ?? [])).catch(() => setData([])).finally(() => setLoading(false));
  }, [path]);
  useEffect(() => { reload(); }, deps); // eslint-disable-line
  return { data, loading, reload, setData };
}

export function Table({ headers, children }) {
  return (
    <div className={`${CARD} overflow-hidden`}>
      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm">
          <thead className="bg-[#F8F9FA] text-[11px] uppercase tracking-wider text-[#64748B]">
            <tr>{headers.map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}</tr>
          </thead>
          <tbody className="divide-y divide-[#F1F5F9]">{children}</tbody>
        </table>
      </div>
    </div>
  );
}
